// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"04347870","75":"3ce271e9","243":"6b6bf02c","420":"9b282448","546":"3396a374","817":"47d744c4","826":"3759b788","844":"be3639ee","863":"1ff9dc47","908":"17a58b6e"}[chunkId] + ".chunk.js";
};